import { useEffect } from 'react'
import { listAllWorkflows, listTeams } from '../application/list-workflows'
import { allWorkflows$, activeWorkflow$, teams$ } from '../store'
import { notify, workflows as workflowsPort } from '../wiring'
import { WorkflowEditorCanvas } from './workflow-editor-canvas'

type Props = {
	workflowId: string
}

// Data is fetched and activeWorkflow$ is set together in a single effect so
// there is no intermediate render where allWorkflows$ has been populated but
// activeWorkflow$ still holds a stale value. syncWorkflow (in canvas actions)
// keeps activeWorkflow$ current for all subsequent mutations, so no second
// effect is needed.
const WorkflowEditorPage = ({ workflowId }: Props) => {
	useEffect(() => {
		let mounted = true

		Promise.all([listAllWorkflows(workflowsPort, notify), listTeams(workflowsPort, notify)]).then(([wfs, tms]) => {
			if (!mounted) return
			allWorkflows$.set(wfs)
			teams$.set(tms)
			activeWorkflow$.set(wfs.find(w => w.id === workflowId) ?? null)
		})

		return () => {
			mounted = false
		}
	}, [workflowId])

	return (
		<div className='-mx-4 md:-mx-8 h-[calc(100dvh-70px)]'>
			<WorkflowEditorCanvas />
		</div>
	)
}

export { WorkflowEditorPage }
